module.exports = __webpack_public_path__ + "static/media/certs7.7d7806b5.png";